import React, { useState } from "react";

import { Box, TextField, Hidden } from "@material-ui/core";
import * as Icons from "@material-ui/icons";

export function SearchBar({ onSearch }) {
  const [searchValue, setSearchValue] = useState("");

  const onKeyPress = (prop) => (e) => {
    setSearchValue(e.target.value);
    if (e.key === "Enter") {
      if (e.target.value.length) {
        onSearch(e.target.value);
      }
    }
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Box
        border={1}
        borderRadius={25}
        p={1}
        mr={1}
        onClick={() => {
          if (searchValue) {
            onSearch(searchValue);
          }
        }}
        style={{ cursor: "pointer" }}
      >
        <Icons.SearchOutlined style={{ color: "black", fontSize: 25 }} />
      </Box>
      <Hidden mdUp>
        <Box mb={1} width="100%">
          <TextField
            fullWidth
            id="input-with-icon-grid"
            label="Search by occupation name"
            onChange={onKeyPress()}
            onKeyPress={onKeyPress()}
          />
        </Box>
      </Hidden>
      <Hidden mdDown>
        <Box mb={1} width="35%">
          <TextField
            fullWidth
            id="input-with-icon-grid"
            label="Search by occupation name"
            onChange={onKeyPress()}
            onKeyPress={onKeyPress()}
          />
        </Box>
      </Hidden>
      <Hidden only={["lg", "sm", "xl", "xs"]}>
        <Box mb={1} width="35%">
          <TextField
            fullWidth
            id="input-with-icon-grid"
            label="Search by occupation name"
            onChange={onKeyPress()}
            onKeyPress={onKeyPress()}
          />
        </Box>
      </Hidden>
    </Box>
  );
}
